export function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result))
    reader.onerror = () => reject(reader.error)
    reader.readAsDataURL(blob)
  })
}

export async function prepareWhatsAppPhoto(photo: Blob, qrToken: string): Promise<Blob> {
  const { default: QRCode } = await import('qrcode')
  const canvas = document.createElement('canvas')
  canvas.width = 1200
  canvas.height = 628
  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('Canvas is unavailable')

  const bitmap = await createImageBitmap(photo)
  const photoWidth = 780
  const scale = Math.max(photoWidth / bitmap.width, canvas.height / bitmap.height)
  const width = bitmap.width * scale
  const height = bitmap.height * scale
  ctx.drawImage(bitmap, (photoWidth - width) / 2, (canvas.height - height) / 2, width, height)
  bitmap.close()

  ctx.fillStyle = '#FFFFFF'
  ctx.fillRect(photoWidth, 0, canvas.width - photoWidth, canvas.height)

  const qrSize = 340
  const qrDataUrl = await QRCode.toDataURL(qrToken, { margin: 3, width: qrSize, color: { dark: '#07130D', light: '#FFFFFF' } })
  const qrImage = new Image()
  qrImage.src = qrDataUrl
  await qrImage.decode()
  const qrLeft = photoWidth + (canvas.width - photoWidth - qrSize) / 2
  const qrTop = (canvas.height - qrSize) / 2
  ctx.drawImage(qrImage, qrLeft, qrTop, qrSize, qrSize)

  return new Promise((resolve, reject) => canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error('Could not create pass image')), 'image/jpeg', 0.82))
}
